<!--
 * @Author: zouyuping
 * @version: 
 * @Date: 2022-04-18 15:48:13
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-03-24 11:31:57
 * @FilePath: 
 * @Description: 业绩汇总
-->
<template>
  <div class="c-p-t-20 full_page_grey">
    <date-tab-com
      ref="dateTabRef"
      @change="handleChangeDateType"
      @changeDate="handleChangeDateData"
    ></date-tab-com>
    <ul class="statistics_item_con">
      <li v-for="(item, index) in functionList" :key="index">
        <p class="c-ft-24">{{ item.title }}</p>
        <div class="statistics_count_con">
          {{
            totalInfo[item.key] == 0 || totalInfo[item.key]
              ? totalInfo[item.key]
              : "--"
          }}
        </div>
      </li>
    </ul>
    <!-- <div class="chart_con">
      <div
        id="myChart"
        ref="myChart"
        :style="{ width: '100%', height: '300px' }"
      ></div>
    </div> -->
  </div>
</template>

<script>
import DateTabCom from "./comps/dateTabCom.vue";
import { getTotalPerformance } from "@/api/performance";
//按需引入
let echarts = require("echarts/lib/echarts");
require("echarts/lib/chart/line"); //线型图
require("echarts/lib/component/tooltip"); //tooltip
require("echarts/lib/component/legend"); //图例
require("echarts/lib/component/grid"); //图例
export default {
  name: "TotalPerformance",
  props: {},
  data() {
    return {
      totalInfo: {},
      functionList: [
        { title: "营业总收入", key: "ConsumptionTotal" },
        { title: "提成汇总", key: "Bonus" },
        { title: "费用汇总", key: "Cost" },
        { title: "营业利润", key: "GrossProfit" },
        { title: "总收款", key: "ConsumptionReceipts" },
        { title: "充值金额", key: "RechargeMoney" },
        { title: "会员卡消费", key: "CardConsumeMoney" },
        { title: "现金实付", key: "CashReceipts" },
        { title: "下单客流量", key: "CheckinCount" },
        { title: "结账客流量", key: "CheckoutCount" },
        { title: "客单价", key: "AverageConsumeMoney" },
        { title: "做钟数量", key: "ClockCount" },
        { title: "排钟数", key: "SortCount" },
        { title: "点钟数", key: "PointCount" },
        { title: "选钟数", key: "ChoseCount" },
        { title: "做钟提成", key: "JishiPersumeAmount" },
        { title: "新增会员数", key: "NewMemberCount" },
        { title: "会员续充", key: "RenewalMemberCount" },
        { title: "会员账单数", key: "MemberBillCount" },
        { title: "现金账单数", key: "CashBillCount" },
        { title: "赠单数量", key: "GiftCount" },
        { title: "赠单金额", key: "GiftAmount" },
        { title: "销售商品数", key: "GoodsCount" },
        { title: "商品销售额", key: "GoodsAmount" },
      ],
    };
  },
  components: { DateTabCom },
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.dateType = this.$refs.dateTabRef.nowDateType;
      this.handleGetTotalPerformance();
    });
    // this.initCharts();
  },
  methods: {
    handleChangeDateType(type) {
      this.dateType = type;
      if (this.dateType !== 4) {
        this.handleGetTotalPerformance();
      }
    },
    handleChangeDateData(dateArr) {
      this.startDate = dateArr[0];
      this.endDate = dateArr[1];
      this.handleGetTotalPerformance();
    },
    handleGetTotalPerformance() {
      const queryData = {
        Query: {
          TimeType: this.dateType,
          VpnId: this.$store.state.vpnId,
        },
      };
      if (this.dateType == 4) {
        queryData.Query.BeginTime = this.startDate;
        queryData.Query.EndTime = this.endDate;
      }
      getTotalPerformance(queryData).then((res) => {
        this.totalInfo = res;
      });
    },
    initCharts() {
      // this.chart = echarts.init(document.getElementById('myChart'))
      this.chart = echarts.init(this.$refs.myChart);
      let option = {
        tooltip: {
          trigger: "axis",
        },
        legend: {},
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: "营业总收入",
            type: "line",
            data: [120, 132, 101, 134, 90, 230, 210],
          },
          {
            name: "营业利润",
            type: "line",
            data: [220, 182, 191, 234, 290, 330, 310],
          },
        ],
      };
      this.chart.setOption(option);
    },
  },
};
</script>
<style scoped lang="scss">
.statistics_item_con {
  display: flex;
  flex-wrap: wrap;
  padding: 20px;
  li {
    width: 23%;
    padding: 30px 0;
    border: 1px solid #eee;
    background: #fff;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
    margin-bottom: 10px;
    &:nth-child(4n) {
      margin-right: 0;
    }
    .statistics_count_con {
      font-size: 30px;
      font-weight: bold;
      margin-top: 10px;
    }
  }
}
.chart_con {
  margin: 20px;
  padding: 10px;
  border-radius: 10px;
  border: 1px solid #eee;
  background: #fff;
  box-sizing: border-box;
}
</style>
